import { render } from "./ModalNotesDelete.vue?vue&type=template&id=5f11d5fc&scoped=true"
import script from "./ModalNotesDelete.vue?vue&type=script&lang=js"
export * from "./ModalNotesDelete.vue?vue&type=script&lang=js"

import "./ModalNotesDelete.vue?vue&type=style&index=0&id=5f11d5fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f11d5fc"]])

export default __exports__